import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

type Props = {
  expanded: boolean
}

const useStyles = makeStyles<Theme, Props>(theme => ({
  root: {
    marginLeft: '-0.3rem',
    height: '24px',
    width: '24px',
    fontSize: theme.size.sm
  },

  container: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '1.5rem',
    width: '1.5rem',
    transform: ({ expanded }) => `rotate(${expanded ? 0 : -180}deg)`,
    transition: 'transform 500ms'
  },

  icon: {
    color: theme.palette.primary.main,
    fontSize: theme.size.lg
  }
}))

export default useStyles
